import { useEffect } from 'react';

import { Seo } from '../components/Seo';
import { faq } from '../content/faq';
import { track } from '../lib/analytics';
import { AssessmentPreview } from '../sections/AssessmentPreview';
import { Faq } from '../sections/Faq';
import { FinalCta } from '../sections/FinalCta';
import { Hero } from '../sections/Hero';
import { HowItWorks } from '../sections/HowItWorks';
import { Problem } from '../sections/Problem';
import { SocialProof } from '../sections/SocialProof';

const TITLE = 'Prepzio — You use AI. Are you actually getting better?';
const DESCRIPTION =
  'Prepzio helps junior developers measure real skill, see where they lean on AI, and practice until they can explain and debug on their own. Join the beta waitlist.';

const applicationLd = {
  '@context': 'https://schema.org',
  '@type': 'SoftwareApplication',
  name: 'Prepzio',
  applicationCategory: 'EducationalApplication',
  operatingSystem: 'iOS, Android',
  description: DESCRIPTION,
  offers: {
    '@type': 'Offer',
    price: '0',
    priceCurrency: 'USD',
    availability: 'https://schema.org/PreOrder',
  },
  audience: {
    '@type': 'Audience',
    audienceType: 'Junior software developers',
  },
};

const faqLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faq.map((item) => ({
    '@type': 'Question',
    name: item.q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.a,
    },
  })),
};

const Landing = () => {
  useEffect(() => {
    track('landing_view');
  }, []);

  return (
    <>
      <Seo title={TITLE} description={DESCRIPTION} path="/" jsonLd={[applicationLd, faqLd]} />
      <Hero />
      <Problem />
      <AssessmentPreview />
      <HowItWorks />
      <SocialProof />
      <FinalCta />
      <Faq />
    </>
  );
};

export default Landing;
